import * as React from 'react';
import { useSelector } from 'react-redux';
import sanitize from 'sanitize-html';

import { selectListingSeoData } from '../../../common/selectors/listingOffers';
import { SeoMarkedList } from '../../components';

export function SeoMarkedListContainer() {
  const seoData = useSelector(selectListingSeoData);
  const items = seoData.markedList?.items;

  const sanitizedItems = React.useMemo(
    () =>
      (items ?? []).map(item => ({
        ...item,
        title: item.title ? sanitize(item.title) : item.title,
        content: item.content ? sanitize(item.content) : item.content,
      })),
    [items],
  );

  if (!items?.length) {
    return null;
  }

  return <SeoMarkedList items={sanitizedItems} />;
}
